import { jsPDF } from 'jspdf';
import ExcelJS from 'exceljs';
import { ReportData } from '../ReportGeneratorTypes';
import { getCharterersText, getFormattedDate, getLetterForNumber } from '../excelReportUtils';

/**
 * Generates a PDF report header with the Odfjell logo
 * @param doc - jsPDF document instance
 * @param data - data object containing vessel and port call information
 */
export function generateReportHeaderPdf(doc: jsPDF, data: ReportData, headerTitle: string, orientation: string): void {
    doc.setFontSize(11);
    doc.addImage('/assets/logos/odfjell_logo.png', 'PNG', 13, 5, 18, 13);

    doc.text(data.vessel.vesselName, 35, 10);
    doc.text(headerTitle, 35, 16);
    if (data.selectedCharterers && data.selectedCharterers.length > 0) {
        const charterersText = getCharterersText(data.selectedCharterers);
        doc.text(charterersText, 120, 10);
    }
    const today = new Date();
    const formattedDate = getFormattedDate(today);
    doc.setFontSize(9);
    doc.text(`Created ${formattedDate}`, orientation === 'portrait' ? 180 : 250, 17);

    doc.setLineWidth(0.3);
    doc.line(10, 20, orientation === 'portrait' ? 210 : 287, 20);
}

export function generateReportHeaderExcel(
    worksheet: ExcelJS.Worksheet,
    vesselName: string,
    title: string,
    charterers: string[],
    logoImageId: number,
    endColumn: number = 12
): void {
    worksheet.mergeCells('A1:B5');
    worksheet.addImage(logoImageId, 'A1:B5');
    worksheet.mergeCells('C2:G2');
    worksheet.getCell('C2').value = vesselName;
    worksheet.getCell('C2').font = { size: 16, bold: true };
    worksheet.mergeCells('C4:G4');
    worksheet.getCell('C4').value = title;
    worksheet.getCell('C4').font = { size: 16, bold: true };
    if (charterers && charterers.length > 0) {
        worksheet.mergeCells(`I4:${getLetterForNumber(endColumn)}4`);
        const charterersText = getCharterersText(charterers);
        worksheet.getCell('I4').value = charterersText;
    }
    const today = new Date();
    const formattedDate = getFormattedDate(today);
    worksheet.mergeCells(`${getLetterForNumber(endColumn - 2)}2:${getLetterForNumber(endColumn)}2`);
    const createdCell = worksheet.getCell(`${getLetterForNumber(endColumn - 2)}2`);
    createdCell.value = 'Created ' + formattedDate;
    createdCell.font = { size: 12 };
    createdCell.alignment = { horizontal: 'center' };

    worksheet.mergeCells(`A6:${getLetterForNumber(endColumn)}6`);
    // set a border on the bottom of A5:M5 range
    worksheet.getCell('A6').border = {
        bottom: { style: 'medium' },
    };
    worksheet.getRow(6).height = 2;
}
